<template>
  <v-card
    max-width="100%"
    class="data"
    elevation="0"
  >
    <v-card-text>
      <p class="card-title text--primary">
        SSH Keys
      </p>
      <div class="text--primary">
        <v-col cols="12" md="12">
          <strong>Add an SSH key</strong>

          <p>To add an SSH key you need to generate one or use an existing key. </p>

          <strong>Key</strong>
          <p>Paste your public SSH key, which is usually contained in the file '~/.ssh/id_ed25519.pub' or '~/.ssh/id_rsa.pub' and begins with 'ssh-ed25519' or 'ssh-rsa'. <strong>Don't use your private SSH key</strong>.</p>
          <v-textarea
            solo
            name="input-7-4"
            label='Typically starts with "ssh-ed25519 …" or "ssh-rsa …"'
            hide-details
            v-model="key"
          ></v-textarea>
        </v-col>

        <v-col cols="12" md="12">
          <p>Give your individual key a title</p>
          <v-text-field
            label="e.g. My MacBook key"
            solo
            hide-details
            v-model="title"
            maxlength="98"
          ></v-text-field>
					<div class="text-right">
						<v-btn
							color="#6db42c"
							class="cta-button mt-4"
							@click="addKey"
							:disabled="!key || !title"
						>
							ADD KEY
						</v-btn>
					</div>
				</v-col>

				<v-col cols="12" md="12">
					<strong>Your SSH keys:</strong>

					<v-data-table
						:headers="headers"
						:items="parsedSSHKeys"
						class="elevation-1 your-keys"
						no-data-text="There are no SSH keys."
						hide-default-footer
					>
						<template v-slot:item.action="{ item }">
							<v-icon
								small
								class="mr-3"
								@click="deleteKey(item)"
							>
								far fa-trash-alt
							</v-icon>
						</template>
					</v-data-table>
				</v-col>


      </div>
    </v-card-text>

    <DeleteDialog
      :selectedKeyToDelete="selectedKeyToDelete"
      :showDeleteDialog.sync="showDeleteDialog"
      @cancelDeleteDialog="cancelDeleteDialog"
      @confirmDeleteDialog="confirmDeleteDialog"
      :loading="deleteKeyLoading"
    />

  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DeleteDialog from './DeleteDialog';

export default {
  data: () => ({
    key: '',
    title: '',
    headers: [
      {
        text: 'Title',
        align: 'start',
        sortable: false,
        value: 'Title',
      },
      {
        text: 'Created',
        align: 'end',
        sortable: false,
        value: 'CreatedAt',
      },
      {
        text: 'Action',
        align: 'end',
        sortable: false,
        value: 'action',
      },
    ],
    keys: [
      {
        id: 1,
        title: 'My MacBook key',
        created: '8 months ago',
        action: '',
      },
    ],
    showDeleteDialog: false,
    selectedKeyToDelete: {},
    deleteKeyLoading: false
  }),
  computed: {
    ...mapGetters(['SSHKeys']),
    parsedSSHKeys() {
      const date = new Date();
      const currentDate = new Date(date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate());

      return this.SSHKeys.map(key => {
        const KeyCreatedAt = new Date(key.CreatedAt.split(" ")[0].replace(/-/g, '/'))
        const diffTime = Math.abs(currentDate - KeyCreatedAt)
        const diffDay = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        let created;

        if (diffDay === 0) {
          created = "today"
        } else if (diffDay === 1) {
          created = `${diffDay} day ago`
        } else {
          created = `${diffDay} days ago`
        }

        return {
          ...key,
          CreatedAt: created
        }
      })
    }
  },
  components: { DeleteDialog },
  methods: {
    ...mapActions(['addSSHKey', 'changeLoadingState', 'getSSHKeys', 'deleteSSHKey']),
    async addKey() {
      const { key, title } = this;

      const data = {
        key,
        title
      }
      this.changeLoadingState();
      const { error } = await this.addSSHKey(data);

      if (!error) {
        this.clearForm();
        await this.getKeys();
      }
      
      this.changeLoadingState()
    },
    deleteKey(item) {
      this.selectedKeyToDelete = item;
      this.showDeleteDialog = true

      console.log('this.selectedKeyToDelete', this.selectedKeyToDelete)
    },
    cancelDeleteDialog() {
      this.selectedKeyToDelete = {}
      // this.showDeleteDialog = false
    },
    async confirmDeleteDialog() {
      console.log('TODO DELETE');
      this.deleteKeyLoading = true;

      const data = {
        keyId: this.selectedKeyToDelete.Id
      }
      
      const { error, result } = await this.deleteSSHKey(data);

      if (!error) {
        this.getKeys();
      }

      this.showDeleteDialog = false
      this.deleteKeyLoading = false;
    },
    async getKeys() {
      this.changeLoadingState()
      await this.getSSHKeys();
      this.changeLoadingState()
    },
    clearForm() {
      this.key = '';
      this.title = '';
    }
  },
  async beforeMount() {
    this.getKeys()
  }
}
</script>

<style scoped>
.data {
  overflow: hidden;
}

.card-title {
  font-size: 2.125rem !important;
  font-weight: bold;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em;
  text-transform: uppercase;
  padding-left: 10px;
}

.your-keys {
  margin-top: 10px;
}

.cta-button:disabled { margin-top: 16px; }

.cta-button {
  color: white;
}

.v-menu__content theme--light .menuable__content__active{ z-index: 9999999999 !important; }
</style>
